export default "__VITE_ASSET__CcMgNQv0__"